import React from 'react'

const RoutingContext = React.createContext()

RoutingContext.displayName = `RoutingContext`

export default RoutingContext
